import { ContractsStore } from "@/services/stores/types";

export const selectContractsStore = ({
  contracts,
  setContracts,
}: ContractsStore) => ({
  contracts,
  setContracts,
});

export const selectContractsData = ({ contracts }: ContractsStore) => ({
  contracts,
});
